import React from "react";
import { Marker, Pane } from "react-leaflet";
import { drawnEmissionMarker } from "./EmissionDrawing";
import { connect } from "react-redux";

class EmissionDrawingMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Pane>
          {this.props.currentCursorCoords &&
            this.props.displayEmissionCursor && (
              <Marker
                icon={drawnEmissionMarker}
                position={this.props.currentCursorCoords}
                zIndex={1}
                zIndexOffset={1}
              />
            )}
        </Pane>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCursorCoords: state.map.currentCursorCoords,
    displayEmissionCursor: state.map.displayEmissionCursor,
  };
};

export default connect(mapStateToProps, null)(EmissionDrawingMovement);
